import { getTweetAnalysisLimit } from '@/lib/ai/model-capabilities';

export const USER_ANALYSIS_DEFAULT_TWEET_TARGET = 800;
export const USER_ANALYSIS_TWEET_LIMIT = getTweetAnalysisLimit();

export {
  BASE_ANALYSIS_TWEET_LIMIT as USER_ANALYSIS_BASE_TWEET_LIMIT,
  getModelCapabilityProfile,
  getTweetAnalysisLimit as getUserAnalysisTweetLimit,
  LARGE_CONTEXT_ANALYSIS_TWEET_LIMIT as USER_ANALYSIS_LARGE_CONTEXT_TWEET_LIMIT,
  type ModelContextTier,
  resolveAnalysisModelId,
  ULTRA_CONTEXT_ANALYSIS_TWEET_LIMIT as USER_ANALYSIS_ULTRA_CONTEXT_TWEET_LIMIT,
} from '@/lib/ai/model-capabilities';
